/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { NameValue } from '../../tool/name-value';
import { RelationType } from './relation-type.enum';

export class Relation {
  public type: RelationType;
  public fields: string[];
  public params: NameValue[];

  constructor(type: RelationType, fields: string, params: string) {
    this.type = type;
    this.fields = fields.split('|');
    this.params = this.initParams(params);
  }

  private initParams(value: string): NameValue[] {
    const params: NameValue[] = [];
    if (typeof value === 'string' && value.indexOf('=') >= 0) {
      for (const s of value.split('|')) {
        const index = s.indexOf('=');
        /* istanbul ignore else */
        if (index >= 0) {
          const name = s.slice(0, index);
          const v = s.slice(index + 1);
          params.push(new NameValue(name, v));
        } else {
          console.error(`Error on expression ${this.toString()}`);
        }
      }
    } else {
      params.push(new NameValue('GLOBAL', value));
    }
    return params;
  }

  public getParam(id: string): any {
    const param = this.params.find((p) => p.name === id);
    return param ? param.value : null;
  }

  public toString(): string {
    return `Type : ${this.type}, Fields: ${this.fields}, Params: ${this.params.join('|')}`;
  }
}
